import { createFileRoute } from "@tanstack/react-router";
import Perfil from "@/pages/app/Perfil";

export const Route = createFileRoute("/app/perfil/")({
  head: () => ({ meta: [{ title: "Perfil | Braussie - Nutri" }] }),
  component: Perfil,
});
